import {appendAndFocusSearchBar} from '@github-ui/append-and-focus-search-bar'
import {DuplicateOnKeydownButton} from '@github-ui/code-view-shared/components/DuplicateOnKeydownButton'
import {useShortcut} from '@github-ui/code-view-shared/hooks/shortcuts'
import {CommandIconButton} from '@github-ui/ui-commands/components/CommandIconButton'
import {SearchIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './SearchButton.module.css'

export default function SearchButton({
  className,
  onClick,
  textAreaId,
}: {
  className?: string
  onClick?: () => void
  textAreaId: string
}) {
  const {searchShortcut} = useShortcut()
  return (
    <>
      <CommandIconButton
        aria-label="Search this repository"
        tooltipDirection="nw"
        icon={SearchIcon}
        commandId="global-navigation:search"
        size="medium"
        className={clsx(styles.IconButton, className)}
        onClick={onClick}
      />
      <DuplicateOnKeydownButton
        buttonFocusId={textAreaId}
        buttonHotkey={searchShortcut.hotkey}
        onButtonClick={() => {
          const textArea = document.getElementById(textAreaId)
          onClick?.()
          appendAndFocusSearchBar({
            retainScrollPosition: true,
            returnTarget: textArea ?? undefined,
          })
        }}
        onlyAddHotkeyScopeButton
      />
    </>
  )
}
